<template>
  <button role="button" @click="onClickLogin">
    <slot>
      <sns-logo-circle sns-name="tid" :width="60" :height="60" />
    </slot>
    <span class="a11y-hidden">T아이디로 로그인</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { getMemberSnsLoginUrl } from '@/common/utils/login'
  import { onMounted, onUnmounted } from 'vue'

  const emit = defineEmits(['success', 'fail'])

  const onClickLogin = () => {
    const snsPopupCallbackUrl = `${location.protocol}//${location.host}/sns-login-callback.html`
    const loginUrl = getMemberSnsLoginUrl({
      type: 'tid',
      callback: snsPopupCallbackUrl,
    })
    window.open(loginUrl, 'tidLogin', 'width=500,height=800')
  }

  const postLoginEventMessage = (event) => {
    if (event?.origin === location.origin) {
      const { eventMessage, params = {} } = event.data || {}
      const { type, token } = params
      if (eventMessage === 'snsLoginInPopup' && type === 'tid') {
        if (token) {
          emit('success', { type, token })
        } else {
          emit('fail', { message: 'Failed to get token' })
        }
      }
    }
  }

  onMounted(() => {
    window.addEventListener('message', postLoginEventMessage)
  })

  onUnmounted(() => {
    window.removeEventListener('message', postLoginEventMessage)
  })
</script>
